module.exports = __webpack_public_path__ + "img/after.812ace67.svg";